import { Component, OnInit } from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";
import { ErrorHandlerDialogComponent } from "../error-handler-dialog/error-handler-dialog.component";
import { DocumentService } from "../../services/document.service";
import { MatDialog } from "@angular/material/dialog";
import { AuthenticationService } from "../authentication/authentication/authentication.service";

const CPDGlossaryID = "cpdglossary";
const CPDGlossaryTitle = "CPD GLOSSARY";

const VehicleCountID = "vehiclecount";
const VehicleCountTitle = "VEHICLE COUNT";

@Component({
    selector: "app-editabledocs",
    templateUrl: "./document.component.html",
    styleUrls: ["./document.component.scss"],
    standalone: false
})
export class DocumentComponent implements OnInit {
  constructor(
    public readonly authService: AuthenticationService,
    private readonly router: Router,
    private readonly editableDocsService: DocumentService,
    private readonly dialog: MatDialog,
    private readonly route: ActivatedRoute
  ) {}

  isLoading = false;

  model = {
    id: "",
    title: "",
    content: "",
    user: "",
  };

  tempContent = "";
  quillConfiguration = {
    toolbar: [
      [{ header: [1, 2, 3, 4, 5, 6, false] }],
      ["bold", "italic"],
      ["link"],
      [{ list: "bullet" }, { list: "ordered" }],
      [{ indent: "+1" }, { indent: "-1" }],
    ],
  };
  notEditing: boolean;

  ngOnInit(): void {
    this.notEditing = true;
    this.route.params?.subscribe((response) => {
      const doc = response.docname;
      this.getDoc(doc);
    });
  }

  public getDocID(): string {
    return this.router.url.split("/").pop();
  }

  public getDoc(name: any): void {
    this.beginLoading();
    this.editableDocsService.getDoc(name).subscribe({
      next: (data: any) => {
        this.handleDocDisplay(data);
      },
      error: (err: any) => {
        this.endLoading();
        this.dialog.open(ErrorHandlerDialogComponent, {
          data: {
            message: err.message,
          },
        });
      },
      complete: () => {
        this.endLoading();
      },
    });
  }

  public updateDoc(): void {
    this.beginLoading();
    this.editableDocsService.updateDoc(this.model).subscribe({
      next: () => {},
      error: (err: any) => {
        this.endLoading();
        this.notEditing = true;
        this.dialog.open(ErrorHandlerDialogComponent, {
          data: {
            message: err.message,
          },
        });
      },
      complete: () => {
        this.endLoading();
        this.notEditing = true;
      },
    });
  }

  public saveDoc(): void {
    this.beginLoading();
    this.editableDocsService.saveDoc(this.model).subscribe({
      next: () => {},
      error: (err: any) => {
        this.endLoading();
        this.notEditing = true;
        this.dialog.open(ErrorHandlerDialogComponent, {
          data: {
            message: err.message,
          },
        });
      },
      complete: () => {
        this.endLoading();
        this.notEditing = true;
      },
    });
  }

  public handleDocDisplay(data: {
    id: string;
    title: string;
    content: string;
  }): void {
    this.model.id = data.id;
    if (data.title == null) {
      if (this.getDocID() === "cpdglossary") {
        this.model.title = CPDGlossaryTitle;
      } else {
        if (this.getDocID() === "vehiclecount") {
          this.model.title = VehicleCountTitle;
        }
      }
    } else {
      this.model.title = data.title;
    }

    this.model.content = data.content;
    this.model.user = this.authService.userInfo.userName;
  }

  public beginLoading(): void {
    this.isLoading = true;
  }

  public endLoading(): void {
    this.isLoading = false;
  }

  public save(): void {
    if (this.model.id == null) {
      if (this.getDocID() === "cpdglossary") {
        this.model.id = CPDGlossaryID;
      } else {
        if (this.getDocID() === "vehiclecount") {
          this.model.id = VehicleCountID;
        }
      }
      this.saveDoc();
    } else {
      this.updateDoc();
    }
  }

  public onReady(_: boolean): void {
    this.notEditing = true;
  }

  public edit(): void {
    this.notEditing = false;
    this.tempContent = this.model.content;
  }

  public cancel(): void {
    this.notEditing = true;
    this.model.content = this.tempContent;
  }
}
